import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import Situation from "./Situation";
import Details from "./Details";
import Letters from "./Letters";
import Checks from "./Checks";
import FilePanel from "./FilePanel";
import Interview from "@/components/interview/Interview";
import { useLocale } from "@/lib/i18n";

const KEYS = ["interview", "situation", "details", "letters", "checks", "file"];

export default function PreparePanel({ caseId, visa, process, onChanged }) {
  const { t } = useLocale();
  const [step, setStep] = useState("interview");
  const [prep, setPrep] = useState(null);
  const [version, setVersion] = useState(0);
  const load = useCallback(() => { api.get(`/cases/${caseId}/prep`).then((r) => setPrep(r.data)).catch(() => setPrep(false)); }, [caseId]);
  useEffect(() => { load(); }, [load]);
  const leave = () => setStep("situation");
  if (prep === false) return <p className="text-sm text-muted">Preparation data could not be loaded.</p>;
  if (!prep) return <div className="h-40 animate-pulse bg-white" />;
  const setData = (d) => setPrep({ ...prep, data: d });
  const setLetters = (l) => setPrep({ ...prep, letters: l });

  return (
    <div data-testid="prepare-panel">
      <ol className="mb-8 flex flex-wrap gap-x-7 gap-y-2 border-b border-navy/10 pb-3">
        {KEYS.map((k) => [k, t(k)]).map(([k, l]) => (
          <li key={k}><button onClick={() => { setStep(k); if (k === "checks") setVersion((v) => v + 1); }} data-testid={`prep-step-${k}`}
            className={`text-sm ${step === k ? "border-b-2 border-navy font-semibold text-navy" : "text-muted hover:text-navy"}`}>{l}</button></li>
        ))}
      </ol>
      {step === "interview" && <Interview caseId={caseId} onFullForm={() => setStep("details")} onNavigate={setStep} onUnavailable={leave} onChanged={() => { onChanged(); }} />}
      {step === "situation" && <Situation caseId={caseId} visa={visa} conditions={prep.conditions} onSaved={() => { load(); onChanged(); }} />}
      {step === "details" && <Details caseId={caseId} schema={prep.schema} data={prep.data} setData={setData} />}
      {step === "letters" && <Letters caseId={caseId} items={prep.letter_items} letters={prep.letters} setLetters={setLetters} />}
      {step === "checks" && <Checks caseId={caseId} refreshKey={version} />}
      {step === "file" && <FilePanel caseId={caseId} forms={prep.form_items} process={process} />}
    </div>
  );
}
